import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Auth from '../services/auth';
import { Link, Redirect } from 'react-router-dom';
import SettingsIcon from '@material-ui/icons/Settings';
import PeopleIcon from '@material-ui/icons/People';
import AssessmentIcon from '@material-ui/icons/Assessment';
import SecurityIcon from '@material-ui/icons/Security';
import StorageIcon from '@material-ui/icons/Storage';
import BusinessIcon from '@material-ui/icons/Business';

const auth = new Auth();

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    card: {
        minHeight: 200,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.shadows[8]
        }
    },
    cardContent: {
        textAlign: 'center',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    cardIcon: {
        fontSize: 48,
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.main
    },
    cardTitle: {
        fontSize: '1.2rem',
        fontWeight: 600,
        marginBottom: theme.spacing(1)
    },
    cardDescription: {
        fontSize: '0.9rem',
        color: theme.palette.text.secondary
    },
    cardActions: {
        justifyContent: 'center',
        paddingBottom: theme.spacing(2)
    },
    adminButton: {
        minWidth: 120
    },
    accessDenied: {
        textAlign: 'center',
        marginTop: theme.spacing(4)
    },
    adminCard: {
        borderTop: `4px solid ${theme.palette.primary.main}`
    }
});

class Administration extends Component {
    displayName = Administration.name;

    constructor(props) {
        super(props);

        this.state = {
            hasAccess: auth.isInADDGroup()
        };
    }

    componentDidMount() {
        document.title = 'Administration - Surgical Notes RCM';
    }

    render() {
        const { classes } = this.props;
        const { hasAccess } = this.state;

        if (!hasAccess) {
            return <Redirect to="/" />;
        }

        const adminOptions = [
            {
                title: 'Transaction Crossmap',
                description: 'Configure system-wide settings and preferences',
                icon: <SettingsIcon className={classes.cardIcon} />,
                link: '/TransactionCrossmap',
                available: true
            },
            {
                title: 'User Administration',
                description: 'Manage users, roles, and permissions',
                icon: <PeopleIcon className={classes.cardIcon} />,
                link: '/UserAdmin',
                available: false
            },
            {
                title: 'Collector Assignment',
                description: 'Configure and manage business workflows',
                icon: <BusinessIcon className={classes.cardIcon} />,
                link: '/CollectorAssignment',
                available: false
            }
        ];

        return (
            <div>
                <Grid className={classes.root} container spacing={4}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Grid className={classes.root} container spacing={4} justifyContent='space-between'>
                                    <Grid item>
                                        <Typography variant="h6">
                                            Administration
                                        </Typography>
                                        <Typography variant="subtitle1">
                                            Administrative tools and configuration options for RCM Global Administrators
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    {adminOptions.map((option, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card className={`${classes.card} ${classes.adminCard}`}>
                                <CardContent className={classes.cardContent}>
                                    {option.icon}
                                    <Typography className={classes.cardTitle}>
                                        {option.title}
                                    </Typography>
                                    <Typography className={classes.cardDescription}>
                                        {option.description}
                                    </Typography>
                                </CardContent>
                                <CardActions className={classes.cardActions}>
                                    {option.available ? (
                                        <Button
                                            component={Link}
                                            to={option.link}
                                            variant="contained"
                                            color="primary"
                                            className={classes.adminButton}
                                        >
                                            Access
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="outlined"
                                            disabled
                                            className={classes.adminButton}
                                        >
                                            Coming Soon
                                        </Button>
                                    )}
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(Administration);
